<spb-borgo-kyc [step]="step()"/>
